import { PopupModal } from "../../components/PopupModal";
import { useUser } from "../auth/context/user-context";
import { useEffect, useState } from "react";
import { Loading } from "../../components/Loading/Loading";
import { api } from "../../services/api";
import { Button } from '../../components/Button';


export type CustomFormDto = {
  title: string;
  description?: string;
  url: string;
  maybeCompleted: boolean;
}

export function SurveyModal() {
  const { userInfo, refreshUserInfo } = useUser();
  const [onLoadCounter, setOnLoadCounter] = useState(0);

  const onSuveryMarkedCompleted = async () => {
    await api.markFormCompleted(userInfo.assignedForms[0].id);
    await refreshUserInfo();
    setOnLoadCounter(0);
  }

  const loading = false

  const form = userInfo?.assignedForms?.[0] as CustomFormDto;

  useEffect(() => {
    if (userInfo?.assignedForms?.[0]?.maybeCompleted) {
      setOnLoadCounter(2);
    }
  }, [userInfo])

  return (
    userInfo?.assignedForms?.[0] ?
      <PopupModal
        contentClassName="p-8 z-[2] w-[98%] self-center bg-white 
      rounded-2xl flex-col justify-start items-center gap-6 flex w-full w-[90%] md:mx-auto md:w-[800px] max-w-[800px]"
        shouldStopPropagation={false}
      >
        {
          loading ? <Loading /> :
            <>
              <div
                className="absolute w-[calc(98%-5px)] max-w-[778px] md:w-[778px] h-[140px] md:h-[115px] mt-[-22px] rounded-lg z-[-1] opacity-80"
                style={{
                  backgroundImage: "linear-gradient(180deg, rgb(196, 243, 229) 0%, rgba(153, 153, 153, 0))",
                  backgroundSize: "contain",
                  backgroundRepeat: "repeat",

                }}
              />
              <div
                className="absolute w-[calc(98%-5px)] max-w-[778px] md:w-[778px] h-[140px] md:h-[115px] mt-[-22px] rounded-lg z-[-1] opacity-100"
                style={{
                  backgroundImage: "url('/images/header-bg-overlay.png')",
                  backgroundSize: "contain",
                  backgroundRepeat: "space",

                }}
              />
              <div className="w-full mx-auto">
                <div className="text-center text-black text-2xl sm:text-4xl font-bold font-['Outfit'] leading-7">
                  Headstart Survey
                </div>

              </div>
              <div className="w-full max-h-[calc(100vh-250px)] lg:max-h-[calc(100vh-250px)] overflow-auto" id="provider-scroll">
                <iframe onLoad={() => {
                  if (onLoadCounter >= 1) {
                    api.markMaybeFormCompleted(userInfo.assignedForms[0].id)
                  }
                  setOnLoadCounter(onLoadCounter + 1)
                }} src={form.url.includes('?') ? `${form.url}&embedded=true` : `${form.url}?embedded=true`} title={`Survey: ${form.title}`} className="w-full h-[calc(100vh-310px)] lg:h-[calc(100vh-310px)]" />

                {onLoadCounter > 1 && <div>
                  <Button
                    type="submit"
                    variant="primary"
                    className="!rounded-full w-full mt-2"
                    // disabled={disabled || saving}
                    loading={loading}
                    onClick={onSuveryMarkedCompleted}
                  >
                    Survey Completed
                  </Button>
                </div>}
              </div>


            </>
        }
      </PopupModal> : null);

}
